import React from 'react';
import Layout from 'components/layout';
import HeaderSection from 'sections/header';
import CategorySection from 'sections/categories';
import CTASection from 'sections/cta';
import InsideYepstr from 'sections/inside-yepstr';
import FooterSection from 'sections/footer';
import TrustPilotTestimonials from 'sections/trustpilot-testimonials';
// import Informational from 'sections/informational';
import Collaborators from 'sections/collaborators';
// import FacebookSection from 'sections/facebook';
import SEO from 'components/seo';
// import TakeOver from './take-over';
// import Carousel from 'sections/carousel';

const IndexTemplate = props => {
  const { seoTitle, seoDescription } = props;
  return (
    <Layout>
      <SEO title={seoTitle} description={seoDescription} />
      <HeaderSection />
      <TrustPilotTestimonials />
      <InsideYepstr />
      {/* <Carousel /> */}
      <CategorySection />
      <CTASection />
      {/* <Informational informationals={allStrapiInformational.nodes} /> */}
      {/* <FacebookSection /> */}
      <Collaborators />
      <FooterSection />
      {/* <TakeOver /> */}
    </Layout>
  );
};
export default IndexTemplate;
